/* tslint:disable */
/* eslint-disable */
/**
 * Eatgrim Shipping API
 * Eatgrim Shipping API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: tech@soundsgood.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function TimeEntryFromJSON(json) {
    return TimeEntryFromJSONTyped(json, false);
}
export function TimeEntryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'startTime': json['startTime'],
        'endTime': json['endTime'],
        'id': json['id'],
        'available': json['available'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'variantId': json['variantId'],
    };
}
export function TimeEntryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'startTime': value.startTime,
        'endTime': value.endTime,
        'id': value.id,
        'available': value.available,
        'description': value.description,
        'variantId': value.variantId,
    };
}
